import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthUserInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const accessToken = localStorage.getItem(`token`);

          // Check if the URL contains the word "login"
    //   if (request.url.includes('login')) {
    //     return next.handle(request);
    //   }

    // if (accessToken) {
    //   request = request.clone({
    //     setHeaders: {
    //       Authorization: `Bearer ${accessToken}`
    //     }
    //   });
    //   return next.handle(request);
    // } else {
    //   const error = new Error('Access token not found in local storage');
    //   this.authService.logout();
    //   return throwError(error);
    // }
    if (accessToken && !request.headers.get('Authorization')) {
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + accessToken,
        },
      });
    }
    return next.handle(request);
  }
}
